import {
  Component,
  NgZone,
  ElementRef,
  OnInit,
  AfterViewInit,
  OnDestroy,
  Output,
  Input,
  OnChanges,
  ViewChild,
  ViewEncapsulation,
  Self,
  DoCheck,
  EventEmitter
} from "@angular/core";
import * as d3 from "d3";
import {
  D3Service,
  D3,
  Axis,
  BrushBehavior,
  BrushSelection,
  D3BrushEvent,
  ScaleLinear,
  ScaleOrdinal,
  Selection,
  Transition
} from "d3-ng2-service";
import { Observable } from "rxjs";
import { NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";


import * as $ from "jquery";
import { EncriptDecriptService } from "../../../../../services/encriptdecript";

@Component({
  selector: "app-learner-status-chart",
  encapsulation: ViewEncapsulation.None,
  templateUrl: "./learner-status-chart.component.html",
  styleUrls: ["./learner-status-chart.component.scss"]
})
export class LearnerStatusChartComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  @ViewChild("chartContainer")
  chartContainer: ElementRef;

  @Input()
  $courseDataset: Observable<any[]>;
  
  @Output() goFront=new EventEmitter();
  public AttemptsList;

  public modalRef: NgbModalRef;
  public selectedCourse: any;
  public selectionCircleId: any;

  private d3: D3;
  private parentNativeElement: any;
  private d3Svg: Selection<SVGSVGElement, any, null, undefined>;
  private zoom: any;
  private rectArea: any;
  private points_g: any;
  private completedCount: number;
  private inprogressCount: number;
  private yetToStartCount: number;
  private circleRadius = 25;
  public courseDataset = [];
  private courseId: any;
  private lessons: any = [];
  private flag = false;
  private coursename: any;
  private selectedCircleRadius: number;
  public quizReviewList = [];
  public quizReviewArray = [];
  public topicList = [];
  public quizLessonObject: any;
  private index;
  private modalConfig: any = {
    backdrop: "static",
    // size: 'lg',
    windowClass: "modal-holder"
    // centered: 'true',
  };

  lessontype: any;
  userDetails:any;
  userObj: any;
  quizReport:any;
  constructor(
    element: ElementRef,
    private zone: NgZone,
    private d3Service: D3Service,
    private modalService: NgbModal,
    private encriptDecript:EncriptDecriptService,
  ) {
    this.d3 = d3Service.getD3();
    console.log(d3Service.getD3());
    this.parentNativeElement = element.nativeElement;
    this.userDetails=this.encriptDecript.getLocalStorage('userObject');
    this.userObj = JSON.parse(this.userDetails);
    this.quizReport = this.userObj.roles[0].isQuizReport;
  }


  ngOnDestroy() {
    this.d3.selectAll("svg").remove();
  }

  ngOnInit() {
  }

  ngOnChanges(){
    this.goFront.emit();
    this.showBackButton=false;
  }

  ngAfterViewInit() {
    this.setLearnerReportData().then(data => {
      this.zone.runOutsideAngular(() => {
        this.createGraph();
      });
    });
  }

  public onSelectCourse() {
    if (!this.selectionCircleId && this.selectedCourse) {
      this.selectionCircleId = this.selectedCourse.categoryId;
      this.showSelectedCourseInGraph();
    } else if (this.selectedCourse) {
      this.d3.select(`#courseId${this.selectionCircleId}`).dispatch("mouseout");
      this.selectionCircleId = this.selectedCourse.categoryId;
      this.showSelectedCourseInGraph();
    } else if (this.selectionCircleId) {
      this.d3.select(`#courseId${this.selectionCircleId}`).dispatch("mouseout");
    }
  }

  private showSelectedCourseInGraph() {
    this.resetZoom();
  }

  private async resetZoom() {
    return new Promise((resolveZoom, reject) => {
      this.points_g
        .transition()
        .duration(750)
        .call(this.zoom.transform, this.d3.zoomIdentity);
      setTimeout(() => resolveZoom("ok"), 800);
    }).then(() => {
      this.d3
        .select(`#courseId${this.selectedCourse.categoryId}`)
        .dispatch("mouseover");
    });
  }

  private setLearnerReportData(): Promise<any[]> {
    return new Promise(resolveData => {
      this.$courseDataset.subscribe(
        reportData => {
          reportData.forEach(el => {
            el.progress["courseStatusDate"] = new Date(el.progress.statusDate);
          });
          this.completedCount = reportData.filter(
            e => e.status.toLowerCase() === "completed"
          ).length;
          this.inprogressCount = reportData.filter(
            e => e.status.toLowerCase() === "in progress"
          ).length;
          this.yetToStartCount = reportData.filter(
            e => e.status.toLowerCase() === "yet to start"
          ).length;
          this.courseDataset = reportData;
          if (reportData.length > 0) {
            resolveData(reportData);
          } else {
          }
        },
        err => console.log(err)
      );
    });
  }

  private createGraph() {
    // // Redraw based on the new size whenever the browser window is resized.
    window.addEventListener("resize", resize);

    const _d3 = this.d3;
    const self = this;
    const svg = _d3.select("svg");
    // // .attr('preserveAspectRatio', 'xMinYMin meet')
    // .attr('class', 'svg-content');

    let currentWidth = parseInt(
      _d3.select("#learner-status-chart").style("width"),
      10
    );
    let currentHeight = parseInt(
      _d3.select("#learner-status-chart").style("height"),
      10
    );
    svg.attr("width", currentWidth);
    svg.attr("height", currentHeight);

    let width = +svg.attr("width");
    width = 0.8 * width;
    let height = +svg.attr("height");
    // height = 0.8 * height;

    const data = self.courseDataset;

    const margin = {
      top: 0.1 * height,
      right: 0.1 * width,
      bottom: 0.3 * height,
      left: 0.2 * width
    };
    const margin2 = {
      top: 0.8 * height,
      right: 0.1 * width,
      bottom: 0.1 * height,
      left: 0.2 * width
    };
    const height2 = height - margin2.top - margin2.bottom;
    // parse the date / time
    // width = width - margin.left - margin.right;
    height = height - margin.top - margin.bottom;

    // set the ranges
    const xScale = _d3
      .scaleTime()
      .range([0.5, width])
      .domain(
        _d3.extent(data, function(d) {
          return d.progress["courseStatusDate"];
        })
      )
      .clamp(false)
      .nice();

    const xScale2 = _d3
      .scaleTime()
      // .domain(_d3.extent(data, function (d) { return (d.progress['courseStatusDate']); }))
      .range([0.5, width])
      .clamp(false)
      .nice();

    if (xScale.domain()[0].getTime() === xScale.domain()[1].getTime()) {
      const dateLess = _d3.timeDay.offset(xScale.domain()[0], -1);
      const dateMore = _d3.timeDay.offset(xScale.domain()[0], 1);
      xScale.domain([dateLess, dateMore]);
    } else {
      const dateLess = _d3.timeYear.offset(xScale.domain()[0], -1);
      const dateMore = _d3.timeYear.offset(
        xScale.domain()[xScale.domain().length - 1],
        1
      );
      xScale.domain([dateLess, dateMore]);
    }

    // create X axis objects
    let xAxis = _d3
      .axisBottom(xScale)
      .tickFormat(_d3.timeFormat("%b-%Y"))
      .ticks(4)
      // .ticks(_d3.timeMonth.every(3))
      .tickSize(0) // <-A
      .tickPadding(3);
    let xAxis2 = _d3
      .axisBottom(xScale2)
      .tickFormat(_d3.timeFormat("%Y"))
      .ticks(5)
      .tickPadding(3);

    const yScale = _d3
      .scaleBand()
      .domain(["Yet To Start", "In Progress", "completed"])
      .rangeRound([height, 0.1])
      .padding(0.15);

    const yScale2 = _d3.scaleBand().rangeRound([height2, 0.1]);

    // function for responsiveness of the graph.
    function resize() {
      if (_d3.select("#learner-status-chart")) {
        currentWidth = parseInt(
          _d3.select("#learner-status-chart").style("width"),
          10
        );
        currentHeight = parseInt(
          _d3.select("#learner-status-chart").style("height"),
          10
        );
        svg.attr("width", currentWidth);
        svg.attr("height", currentHeight);

        width = +svg.attr("width");
        width = 0.8 * width;
        // height = +svg.attr('height');
        xScale.range([0.5, width]);
        xScale2.range([0.5, width]);
        // create X axis objects
        xAxis = _d3
          .axisBottom(xScale)
          .tickFormat(_d3.timeFormat("%b-%Y"))
          .ticks(4)
          .tickSize(0) // <-A
          .tickPadding(3);
        xAxis2 = _d3
          .axisBottom(xScale2)
          .tickFormat(_d3.timeFormat("%Y"))
          .ticks(5)
          .tickPadding(3);
        gX.call(xAxis);
        setSimulation();
        backgroundBar.attr("width", width);
        rectArea.attr("width", width);
        clipPath.attr("width", width);
        brush.extent([[0, 0], [width, 10]]);
        brushBar.call(brush.move, xScale.range());
        renderXGridlines();
      }
    }

    // Dashboard Heading
    const heading = svg
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + 0 + ")")
      .append("text")
      .text("Course Dashboard")
      .attr("fill", "black")
      .attr("x", 1)
      .attr("y", (height / margin.top + height / margin.bottom) * 5)
      .attr("class", "dashboardName");

    function setSimulation(xNewScale?) {
      let xTimelineForce: any;
      if (xNewScale) {
        xTimelineForce = _d3
          .forceX(d => xNewScale(d["progress"]["courseStatusDate"]))
          .strength(0.1);
      } else {
        xTimelineForce = _d3
          .forceX(d => xScale(d["progress"]["courseStatusDate"]))
          .strength(0.1);
      }
      const yStatusForce = _d3.forceY(d => yScale(d["status"])).strength(0.4);
      const chargeForce = _d3.forceManyBody().strength(-5);
      const centerXForce = _d3.forceX(width).strength(0.1);
      const centerYForce = _d3.forceY(yScale.bandwidth() + 10).strength(0.6);
      const forceCollide = _d3
        .forceCollide()
        .strength(0.1)
        // .radius(d => self.circleRadius + 1)
        .radius(d => self.circleRadius)
        .iterations(0.6);

      const simulation = _d3
        .forceSimulation()
        .force("charge", chargeForce)
        .force("collide", forceCollide)
        // .force('x', centerXForce)
        .force("x", xTimelineForce)
        // .force('y', centerYForce)
        .force("y", yStatusForce);

      simulation.nodes(data).on("tick", () => {
        circle
          .attr("cx", d => {
            return d.x;
          })
          .attr("cy", d => d.y + (margin.top - 6));
      });
      simulation.force("x", xTimelineForce);
      simulation.force("y", yStatusForce);
      simulation.alpha(1).restart();
    }

    // Draw X Axis
    const gX = svg
        .append("g")
        .attr("class", "axis axis--x x-axis")
        .attr(
          "transform",
          "translate(" + margin.left + "," + (margin.top + height) + ")"
        )
        .call(xAxis);
      // .selectAll('g text')
      // .attr('class', 'chartTimelineText')

    function renderXGridlines() {
      _d3
        .selectAll("g.x-axis g.tick")
        .select("line.grid-line")
        .remove();

      _d3
        .selectAll("g.x-axis g.tick")
        .append("line")
        .classed("grid-line", true)
        .attr("x1", 0)
        .attr("y1", -10)
        .attr("x2", 0)
        .attr("y2", -(height - 20));
    }
    renderXGridlines();

    // create Y axis objects
    const yAxis = _d3.axisLeft(yScale).tickSize(0);
    // Draw Y Axis
    const gY = svg
      .append("g")

      .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
      .call(yAxis)

      .selectAll("text")
      .attr("x", d => {
        if (d === "completed") {
          return -15;
        } else {
          return -10;
        }
      })
      .attr("fill", d => {
        return "#001d33";
      })
      .style("text-transform", "uppercase")
      .attr("y", yScale.bandwidth() / 4)
      .attr("class", "statusName")
      .append("tspan")
      .attr("dy", "-1em")
      .attr("x", "-55")
      .attr("class", "statusCount")
      .text(d => {
        if (d === "Yet To Start") {
          return `0${this.yetToStartCount}`;
        } else if (d === "completed") {
          return `0${this.completedCount}`;
        } else {
          return `0${this.inprogressCount}`;
        }
      })
      .style("font", "14px");

    const brush = _d3
      .brushX()
      .handleSize(6)
      .extent([[0, 0], [width, 10]])
      .on("brush", brushed);

    // create a clipping region
    const clipPath = svg
      .append("defs")
      .append("svg:clipPath")
      .attr("id", "clip")
      .append("svg:rect")
      .attr("width", width)
      .attr("height", height)
      .attr("x", "0")
      .attr("y", "0");

    const extent: any = [
      [margin.left, margin.top],
      [width - margin.right, height - margin.top]
    ];
    // Pan and zoom
    const zoomHandler = _d3
      .zoom()
      .scaleExtent([1, 2])
      .translateExtent(extent)
      .extent(extent)
      .on("zoom", zoomActions);

    self.zoom = zoomHandler;

    const rectArea = svg
      .append("rect")
      .attr("class", "zoom")
      .attr("width", width)
      .attr("height", height)
      .style("fill", "none")
      .style("pointer-events", "all")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
      .call(<any>zoomHandler);
    self.rectArea = rectArea;

    // Draw Datapoints
    const points_g = svg
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")")
      .attr("clip-path", "url(#clip)")
      .classed("points_g", true)
      .call(<any>zoomHandler);
    self.points_g = points_g;
    const context = svg
      .append("g")
      .attr("class", "context")
      .attr("transform", "translate(" + margin2.left + "," + margin2.top + ")");

    xScale2.domain(xScale.domain());
    // yScale2.domain(yScale.domain());

    const backgroundBar = points_g
      .selectAll(".statusBar")
      .data(["Yet To Start", "In Progress", "completed"])
      .enter()
      .append("rect")
      .attr("class", "statusBar")
      .attr("fill", d => {
        if (d.toLowerCase() === "yet to start") {
          return "#fcbdbd4f";
        } else if (
          d.toLowerCase() === "in progress" ||
          d.toLowerCase() === "inprogress"
        ) {
          // return '#ffc80047';
          // return '#fff0da6b';
          return "#ffcd854f";
        } else {
          return "#d2f5b04f";
        }
      })
      .attr("y", function(d) {
        return yScale(d);
      })
      .attr("height", yScale.bandwidth() + 10)
      .attr("width", function(d) {
        return width;
      });
    renderXGridlines();
    // yScale
    data.map(function(d) {
      return d.status;
    });

    // Add the tooltip container to the vis container
    // it's invisible and its position/contents are defined during mouseover
    const tooltip: any = _d3
      .select("#learner-status-chart")
      .append("div")
      .attr("class", "tooltip")
      .style("display", "none")
      .style("opacity", 0.9);

    // tooltip mouseover event handler
    const tipMouseover = function(d, ele) {
      // const color = colorScale(d.manufacturer
      let html = "";
      switch (<String>d.status.toLowerCase()) {
        case "completed":
          html = `<p>  <strong> Course Name : </strong> ${d.name} <p>
              <p> <strong> Completed Date :</strong> ${
                d.progress.statusDate
              } </p>
            `;
          break;
        case "in progress":
        case "inprogress":
          html = `<p>  <strong> Course Name : </strong> ${d.name} <p>
          <p> <strong> Last Active Date :</strong> ${d.progress.statusDate} </p>
          `;
          break;
        case "yet to start":
          html = `<p>  <strong> Course Name : </strong> ${d.name} <p>
        <p> <strong> Assigned Date :</strong> ${d.progress.statusDate} </p>
      `;
      }

      const pageX = parseFloat(ele.getAttribute("cx")) + 10;
      const pageY = parseFloat(ele.getAttribute("cy")) - 40;
      tooltip
        .html(html)
        .transition()
        .duration(200)
        .style("display", "grid")
        .style("left", pageX + "px")
        .style("top", pageY + "px")
        .style("opacity", 0.9);
    };
    // tooltip mouseout event handler
    const tipMouseout = function(d?) {
      if (d) {
        tooltip
          .transition()
          .duration(200)
          .style("display", "none")
          .style("opacity", 0);
      }
    };

    let circle = points_g.selectAll("circle").data(data);
    circle = circle
      .enter()
      .append("circle")
      .attr("r", d => {
        return self.circleRadius;
      })
      .attr("id", d => {
        return `courseId${d.categoryId}`;
      })
      .attr("fill", d => {
        if (d.status.toLowerCase() === "yet to start") {
          return "#ffd8d4";
        } else if (
          d.status.toLowerCase() === "in progress" ||
          d.status.toLowerCase() === "inprogress"
        ) {
          return "#ffdca7";
        } else {
          return "#dbf9d0";
        }
      })
      .attr("stroke", d => {
        if (d.status.toLowerCase() === "yet to start") {
          return "#ff5d5d";
        } else if (d.status.toLowerCase() === "in progress") {
          return "#fda400";
        } else {
          return "#21ff00";
        }
      })
      .style("pointer-events", "all")
      .on("click", (d, i) => self.onCourseCircleClick(d, i))
      .on("mouseover", function(d, i) {
        self.selectedCircleRadius = _d3.select(this).attr("r")
          ? +_d3.select(this).attr("r")
          : +self.circleRadius;
        _d3
          .select(this)
          // .transition()
          .attr("r", +self.selectedCircleRadius + 5)
          .attr("stroke-width", "2")
          .style("cursor", "pointer");
        tipMouseover(d, this);
      })
      .on("mouseout", function(d, i) {
        _d3
          .select(this)
          // .transition()
          .attr(
            "r",
            () => {
              return self.selectedCircleRadius;
            }
            // 30
          )
          .attr("stroke-width", "1");
        tipMouseout(d);
      });

    context
      .append("g")
      .attr("class", "axis axis--x")
      .attr("transform", "translate(0," + 10 + ")");

    const brushBar = context
      .append("g")
      .attr("class", "brush")
      .call(brush)
      .call(brush.move, xScale.range());

    setSimulation();

    // create brush function redraw scatterplot with selection
    function brushed() {
      // const minSelectionSize = 20;
      if (_d3.event.sourceEvent && _d3.event.sourceEvent.type === "zoom") {
        return;
      } // ignore brush-by-zoom
      const selection = _d3.event.selection || xScale2.range();

      xScale.domain(selection.map(xScale2.invert, xScale2));
      const d0 = selection.map(xScale.invert),
        d1 = d0.map(_d3.timeYear.round);
      points_g.select(".axis--x").call(xAxis);
      svg
        .select(".zoom")
        .call(
          zoomHandler.transform,
          _d3.zoomIdentity
            .scale(width / (selection[1] - selection[0]))
            .translate(-selection[0], 0)
        );
    }

    function zoomActions(): any {
      // if (_d3.event.sourceEvent && _d3.event.sourceEvent.type === 'brush') { return; } // ignore zoom-by-brush
      // create new scale ojects based on event
      const posObjs = [];
      const t = _d3.event.transform;
      const new_xScale = t.rescaleX(xScale);
      const new_xScale2 = t.rescaleX(xScale2);
      const dxPos = [];
      const dYPos = [];
      // const yPosObjs = {};
      // setSimulation(new_xScale);
      gX.call(xAxis.scale(new_xScale));
      circle
        .data(data)
        .attr("cx", function(d) {
          dxPos.push(new_xScale(d.progress["courseStatusDate"]));
          // const posSet = [];
          dYPos.push(yScale(d["status"]));
          const xPosSet = Array.from(new Set(dxPos));
          // const yPosSet = Array.from(new Set(dYPos));

          for (const pos in xPosSet) {
            if (true) {
              posObjs[pos] = {
                positionX: xPosSet[pos],
                positionY: dYPos[pos],
                count: 0
              };
            }
          }
          return new_xScale(d.progress["courseStatusDate"]);
        })
        .attr(
          "r",
          (d, i): any => {
            // const radius = self.circleRadius;
            const countPromise = new Promise((resolveCount, rej) => {
              posObjs.forEach((pos, index, arr) => {
                if (
                  Math.abs(
                    new_xScale(d.progress["courseStatusDate"]) - pos.positionX
                  ) < 55 &&
                  Math.abs(pos.positionY - yScale(d["status"])) <= 0
                ) {
                  pos.count++;
                }
              });
              if (i === data.length - 1) {
                resolveCount(posObjs);
              }
            }).then(() => {
              return 1;
            });
            // return 0;
          }
        )
        .attr("r", (d, i) => {
          const dyScale = yScale(d["status"]);
          return self.setRadius(posObjs, dyScale);
        });
      xScale.domain(new_xScale2.domain());
      context
        .select(".brush")
        .call(brush.move, xScale.range().map(t.invertX, t));
      self.d3.select(`#courseId${self.selectionCircleId}`).dispatch("mouseout");
      renderXGridlines();
      setSimulation(new_xScale);
      tipMouseout();
    }
  }

  private setRadius(posObjs, dyScale) {
    let radius = this.circleRadius;
    for (const pos of posObjs) {
      if (
        pos.count >= 2 &&
        pos.positionY === dyScale
        // && (Math.abs(pos.positionY - dyScale) < 1)
      ) {
        radius = this.circleRadius - (pos.count + 5);
        break;
      } else {
        radius = this.circleRadius;
      }
    }
    return radius;
  }

  public showQuizReview(quizReviewRef) {
    this.modalRef = this.modalService.open(quizReviewRef, this.modalConfig);
    this.modalRef.result.then(
      result => {},
      onDismiss => {
        this.selectedCourse = null;
      }
    );
  }

  public onCourseCircleClick(d, i) {
    this.showCourseDetails(d);
  }

  private showCourseDetails(selectedCourse) {
    this.selectedCourse = selectedCourse;
  }

  public openModal(content) {
    this.d3.select(`#courseId${this.selectionCircleId}`).dispatch("mouseout");
    const modalConfig: any = {
      backdrop: "static",
      // size: 'lg',
      windowClass: "modal-holder"
      // centered: 'true',
    };
    if (this.selectedCourse.course !== 0) {
      this.getFirstObject();
    }
    this.modalRef = this.modalService.open(content, modalConfig);
    this.modalRef.result.then(
      result => {},
      onDismiss => {
        this.selectedCourse = null;
      }
    );
  }
  getFirstObject() {
    this.lessons = this.selectedCourse.course[0].lesson[0];
    this.coursename = this.selectedCourse.course[0].name;
    this.quizReviewArray = this.lessons;
    this.changeSection(0, null);
  }
  dismissModal() {
    this.coursename = "";
    this.lessons = [];
    this.quizReviewArray = [];
    this.showBackButton=false;
    this.modalRef.dismiss();
  }
  onCloseModal() {
    this.coursename = "";
    this.lessons = [];
    this.modalRef.close();
  }

  public getTopics(i, course) {
    this.coursename = "";
    // this.flag === false ? this.flag = true : this.flag = false;
    if (course) {
      this.courseId = course.courseId;
      this.coursename = course.name;
      this.changeSection(i, this.courseId);
    }
  }
  changeSection(i, id) {
    let courses = [];
    if (this.selectedCourse !== undefined) {
      courses = this.selectedCourse.course;
      this.lessons = courses[i].lesson;
      this.quizReviewArray = this.lessons;
    }
    // this.lessons = courses.filter(course =>
    //   course.courseId === id).map(course => {
    //     return course.lesson;
    //   })[0];
    // this.lessons=courses[i].lesson;
    // this.quizReviewArray=this.lessons;
  }

  //  quiz popup
  public getQuizInfo(i) {
    if (i != undefined && i != null) {
      this.index = i;
      this.quizReviewList = this.quizReviewArray[i].progress;
    }
    const x = document.getElementById("quizInfo");
    var pos = 0;
    var id = setInterval(frame, 0.25);
    function frame() {
      if (pos == 200) {
        clearInterval(id);
      } else {
        pos++;
        x.style.left = pos + "px";
      }
    }
    if (x.style.display === "none") {
      x.style.display = "block";
    } else {
      x.style.display = "none";
    }
  }

  public hideQuizInfo() {
    const x = document.getElementById("quizInfo");
    if (x) {
      x.style.display = "none";
    }
  }
  public showBackButton = false;
  public getQuizDetailedReport(quizReviewList, quizAttempt) {
    this.AttemptsList= quizReviewList.attempts;
    document.getElementById("viewmore").style.display = "none";
    this.showBackButton = true;
    const launchUrl = this.quizReviewArray[this.index].launchUrl;
    const quizQuestionType  = this.quizReviewArray[this.index].quizQuestionType;
    this.quizLessonObject = { launchUrl, quizAttempt ,quizQuestionType};
  }


  goBackpage(event){
    document.getElementById('viewmore').style.display='block';
    this.showBackButton=false;
  }
}



// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/user-module/user-dashboard/user-dashboardcards/charts/learner-status-chart/learner-status-chart.component.ts